import { graphql } from "../gql";

export const setAssigneesMutationDoc = graphql(`
  mutation setAssignees($input: SetAssigneesInput!) {
    setAssignees(input: $input) {
      __typename
    }
  }
`);
